
import api from './api';

const endpoint = '/api/agendamentos';

const AgendamentosService = {
  getAll: async () => {
    const response = await api.get(`${endpoint}/internos`);
    return response.data;
  },

  getPacotes: async () => {
    const response = await api.get(`${endpoint}/pacote`);
    return response.data;
  },

  /** Gerenciamento *******/
  getByData: async (data) => {
    const response = await api.get(`${endpoint}/internos/data/${data}`);
    return response.data;
  },
  
  getByData2: async (data) => {
    // data deve estar no formato 'YYYY-MM-DD'
    const response = await api.get(`${endpoint}/data/${data}`);
    return response.data;
  },

  getCancelar: async () => {
    const response = await api.get(`${endpoint}/internos-cancelamentos`);
    return response.data;
  },

  getNaoRealizados: async () => {
    const response = await api.get(`${endpoint}/internos-faltas`);
    return response.data;
  },

  /** Agendamento *******/
  getById: async (id) => {
    const response = await api.get(`${endpoint}/${id}`
    );
    return response.data;
  },

  /*
  create: async (data) => {
    const response = await api.post(endpoint, data);
    return response.data;
  },
  */

  create: async (data) => {
    const response = await api.post(`${endpoint}/comum`, data);
    return response.data;
  },

  createPacote: async (pacoteDTO) => {
    const response = await api.post(`${endpoint}/pacote`, pacoteDTO);
    return response.data;
  },

  update: async (idAgendamento, data) => {
    const response = await api.put(`${endpoint}/publico/${idAgendamento}`, data);
    return response.data;
  },

  cancelarPublico: async (idAgendamento, data) => {
    const response = await api.put(`${endpoint}/cancelar/${idAgendamento}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },

  /** Perfil *******/ 
  getByCadastro: async (idCadastro) => {
    const response = await api.get(`/api/agendamentos/cadastro/${idCadastro}`);
    return response.data;
  },

  getHistoricoByCadastro: async (idCadastro) => {
    const response = await api.get(`/api/agendamentos/historico/${idCadastro}`);
    return response.data;
  },

  getAgendamentosAtivos: async(idCadastro) =>{
    const response = await api.get(`/api/agendamentos/ativos/${idCadastro}`);
    return response.data
  },

  /** Marcar Como no Gerenciamento ****/
  updateRealizado: async (idAgendamento, data) => {
    const response = await api.patch(`${endpoint}/realizado/${idAgendamento}`, data);
    return response.data;
  },

  updateCancelado: async (idAgendamento, data) => {
    const response = await api.patch(`${endpoint}/cancelado/${idAgendamento}`, data);
    return response.data;
  }

};

export default AgendamentosService;